import { getOverrideRemoteEntries, setOverrideRemoteEntries } from '@cko/dashboard-shared';
import { FeatureFlagOverrides, Overrides, PermissionsOverrides } from './types';

const PERMISSIONS_KEY = 'dev.override.permissions';
const FEATURE_FLAG_KEY = 'dev.override.featureFlags';

const addToLocalStorage = (key: string, value: unknown) => {
  try {
    const valueToStore = JSON.stringify(value);
    localStorage.setItem(key, valueToStore);
  } catch {
    //noop
  }
};

const getFromLocalStorage = <T>(key: string, defaultValue: T): T => {
  try {
    const storedValue = localStorage.getItem(key);
    if (storedValue === null) {
      return defaultValue;
    }
    return JSON.parse(storedValue) as T;
  } catch {
    return defaultValue;
  }
};

export const saveContextToLocalStorage = (overrides: Overrides) => {
  if (overrides.mfeEntries) {
    setOverrideRemoteEntries(overrides.mfeEntries);
  }

  if (overrides.featureFlags) {
    addToLocalStorage(FEATURE_FLAG_KEY, overrides.featureFlags);
  }

  if (overrides.permissions) {
    addToLocalStorage(PERMISSIONS_KEY, overrides.permissions);
  }
};

export const getContextFromLocalStorage = (): Overrides => {
  const overrides: Overrides = {
    permissions: getFromLocalStorage<PermissionsOverrides>(PERMISSIONS_KEY, {}),
    featureFlags: getFromLocalStorage<FeatureFlagOverrides>(FEATURE_FLAG_KEY, {}),
    mfeEntries: getOverrideRemoteEntries() || {},
  };
  return overrides;
};
